/* eslint-disable react/prop-types */
import { Button } from '@material-ui/core'
import { useSnackbar } from 'notistack'
import React from 'react'
import { CopyToClipboard } from 'react-copy-to-clipboard'

const CopyClipBoard = ({
  link, text, rowData, style, ...props
}) => {
  const { enqueueSnackbar } = useSnackbar()
  const onCopy = () => {
    enqueueSnackbar('Berhasil di copy', { variant: 'success' })
  }

  return (
    <CopyToClipboard
      text={link}
      onCopy={onCopy}
      style={style}
    >
      <Button
        color="primary"
        {...props}
      >
        {text || 'Copy URL Link'}
      </Button>
    </CopyToClipboard>
  )
}
export default CopyClipBoard
